import { AxiosInterceptor } from "api/core/consts";

export const processLogApi = {
  getProcessLog: (processLogId) =>
    AxiosInterceptor.get('processLog/' + processLogId),
};
